export const machineTraining = [
    { title: "Excavator", price: 190, duration: "2 weeks" },
    { title: "Loader / Front Loader", price: 180, duration: "2 weeks" },
    { title: "TLB", price: 180, duration: "2 weeks" },
    { title: "Mobile Crane", price: 450, duration: "2 weeks" },
    { title: "Drill Rig", price: 450, duration: "2 weeks" },
    { title: "Grader", price: 250, duration: "2 weeks" },
    { title: "Tipper", price: 200, duration: "2 weeks" },
  ];
  
  export const otherCourses = [
    {
      title: "First Aid",
      price: 150,
      duration: "1 week",
      description:
        "Learn emergency response, CPR basics, wound care, shock management, and safe patient handling. Ideal for workplaces and safety teams.",
    },
    {
      title: "Superlink",
      price: 500,
      duration: "2 weeks",
      description:
        "Learn to operate double link trailers,class 2 licence and defensive driving required",
    },
    {
      title: "Solar Installation",
      price: 250,
      duration: "3 weeks",
      description:
        "Install and maintain solar systems: panels, inverters, batteries, wiring, load calculations, troubleshooting, and safety.",
    },
    {
      title: "Welding",
      price: 380,
      duration: "3 months",
      description:
        "Hands-on welding skills: safety, measurements, joint preparation, practical techniques, and workshop discipline.",
    },
    {
      title: "Plumbing",
      price: 380,
      duration: "3 months",
      description:
        "Pipe fitting, repairs, drainage basics, installations, tools usage, and job-ready practical work.",
    },
    {
      title: "Panel Beating",
      price: 300,
      duration: "3 months",
      description:
        "Vehicle body repair fundamentals: dents, sanding, shaping, finishing, and workshop safety.",
    },
    {
      title: "CCTV Installation",
      price: 200,
      duration: "2 weeks",
      description:
        "CCTV installation: DVR/NVR setup, cable routing, remote viewing configuration, and basic troubleshooting.",
    },
    {
      title: "DPF",
      price: 480,
      duration: "4 months",
      description:
        "Diesel Particulate Filter training: diagnostics, cleaning processes, fault detection, and maintenance best practices.",
    },
    {
      title: "Mechanics",
      price: 380,
      duration: "3 months",
      description:
        "Vehicle service basics: diagnostics, engine systems overview, brakes/suspension, and maintenance routines.",
    },
    {
      title: "Baking",
      price: 200,
      duration: "1 month",
      description:
        "Baking basics: hygiene, mixing methods, bread/cake foundations, costing basics, and consistent production.",
    },
    {
      title: "Electrical Power",
      price: 480,
      duration: "6 months",
      description:
        "Electrical fundamentals: wiring, circuits, safety, installation standards, fault finding, and practical projects.",
    },
    {
      title: "Barber & Salon",
      price: 200,
      duration: "TBA",
      description:
        "Barbering & salon fundamentals: hygiene, tools, basic cuts, styling, customer care, and business basics.",
    },
    {
      title: "Phone Electronics",
      price: 100,
      duration: "2 weeks",
      description:
        "Phone diagnostics, screen/battery replacement, charging faults, basic soldering, and common repair procedures.",
    },
    {
      title: "Professional Chef",
      price: 200,
      duration: "3 weeks",
      description:
        "Kitchen hygiene, food preparation, plating basics, menu planning foundations, and kitchen workflow.",
    },
  ];